import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows, breakpointsMQ4, typography } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const CardStyled = styled.li<{ $isChecked: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 20rem;
  align-items: center;
  padding: 2rem 3rem;
  box-sizing: border-box;
  background-color: ${colors.neutral.white};
  box-shadow: ${boxShadows.light[4]};
  border-radius: 10px;
  border: 1px solid ${({ $isChecked }): string => ($isChecked ? colors.blue[600] : colors.neutral[300])};
  transition: border-color 0.3s;

  &::before {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 1rem;
    border-radius: 8px 0 0 8px;
    background-color: ${colors.blue[600]};
    opacity: ${({ $isChecked }): number => ($isChecked ? 1 : 0)};
    transition: opacity 0.1s ease-out;
  }

  ${breakpointsMQ4.md.down} {
    grid-template-columns: 1fr;

    &::before {
      inset: 0 0 auto;
      width: auto;
      height: 1rem;
      border-radius: 10px 10px 0 0;
    }
  }
`;

export const EmailInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  padding-right: 3rem;
  border-right: 1px solid ${colors.neutral[300]};
  min-height: 9rem;

  ${breakpointsMQ4.md.down} {
    padding-right: 0;
    padding-bottom: 2rem;
    border-right: none;
    border-bottom: 1px solid ${colors.neutral[300]};
    margin-bottom: 2rem;
  }
`;

export const TitleStyled = styled.span`
  ${typography.bold[20]};
`;

export const DescriptionStyled = styled.div`
  ${typography.regular[16]};
`;

export const ToggleWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpointsMQ4.md.down} {
    justify-content: flex-start;
  }
`;
